import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 8.069a1.33 1.33 0 0 0-1.33 1.33v5.406a1.33 1.33 0 1 0 2.66 0v-5.406a1.33 1.33 0 0 0-1.33-1.33zm0-4.13c-.734 0-1.33.597-1.33 1.33 0 .734.596 1.33 1.33 1.33.734 0 1.33-.596 1.33-1.33 0-.733-.596-1.33-1.33-1.33z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
